import * as actionTypes from './actionTypes';
import { FilterValuesService } from '@app/src/views/EditUser/editUser/models/FilterUserValues';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';

interface State {
  isFetching: boolean;
  errorMessage: string;
  errorRol: boolean;
  data: FilterValuesService;
}

const initialState = {
  data: {
    code: null,
    data: [],
    message:''
  },
  isFetching: false,
  errorMessage: '',
  errorRol: false
};

export const editUserValues = (state: State = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_EDIT_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
        errorRol: false
      };

    case actionTypes.FETCH_EDIT_USER_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        errorRol: action.errorRol,
        isFetching: false
      };

    case actionTypes.FETCH_EDIT_USER_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        errorMessage: '',
        errorRol: false
      };

    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
}
